import {SpinnerService} from "../../modules/SpinnerModule";
import {DebounceFactory} from "../../modules/DebounceModule";
import {DataHubService} from "../../modules/DataHubModule";
import {StateService} from "@uirouter/angularjs";
import {AuthNetHostedProfilePageTokenRequestDto} from "../../model/AuthNetHostedProfilePageTokenRequestDto";
import {AuthNetHostedProfilePageTokenResultDto} from "../../model/AuthNetHostedProfilePageTokenResultDto";

export class ManageController {
    error: any;
    model: AuthNetHostedProfilePageTokenResultDto;
    form: any;

    constructor($scope,
                private $timeout,
                private $dataHub: DataHubService,
                private $spinner: SpinnerService,
                private $debounce: DebounceFactory,
                private $state: StateService,
                private $stateParams: any) {
        this.refresh();
        $dataHub.onConnected(this.refresh);

    }

    refresh = () => {
        if(!this.$dataHub.isConnected) return;
        this.$spinner.show('Loading');
        var dto: AuthNetHostedProfilePageTokenRequestDto = {
            customerGuid: this.$stateParams.customerGuid,
            authNetAccountGuid: this.$stateParams.gatewayGuid,
            mode: this.$stateParams.mode,
            paymentProfileId: this.$stateParams.paymentProfileId,
            skipValidation: this.$stateParams.skipValidation
        };

        this.$dataHub.server.paymentGetAuthNetHostedProfilePageToken(dto)
            .then(this.updateForm)
            .catch(this.handleError);

    };

    updateForm = (model: AuthNetHostedProfilePageTokenResultDto) => {
        this.model = model;
        console.debug('model', model);
        let formElement = this.form.$$element[0];
        console.log('form', formElement);
        formElement.action = model.url;
        this.$timeout(() => {
            formElement.submit();
            this.$spinner.hide();
        }, 0);
    };


    handleError(e) {
        console.error(e);
        if (e.data && e.data.exceptionMessage) {
            this.error = e.data.exceptionMessage;
        } else {
            this.error = e;
        }
    }


}

